/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */
import { Stack, PrimaryButton, DefaultButton } from "@fluentui/react";
import { IPanelFooterProps } from "./IPanelFooterProps";
import { panelFooterProps } from "./FieldDefinitionPanelStackTokens";

const PanelFooter = (props: IPanelFooterProps): JSX.Element => {
    let stackProps = props.panelFooterProps;

    if (!stackProps) {
        stackProps = panelFooterProps;
    }

    const saveButton = props.isNew ? (
        <PrimaryButton disabled={!props.isValid} onClick={props.onSave}>
            Save
        </PrimaryButton>
    ) : (
        <PrimaryButton disabled={!(props.isDirty && props.isValid)} onClick={props.onSave}>
            Save Changes
        </PrimaryButton>
    );
    return (
        <Stack {...stackProps}>
            {saveButton}
            <DefaultButton onClick={props.onCancel}>Cancel</DefaultButton>
        </Stack>
    );
};

export default PanelFooter;
